import type { MetaDescriptor } from 'react-router'
import { useParams } from 'react-router'
import ServicePageTemplate from '../../templates/ServicePageTemplate'
import NotFoundPage from '../../pages/NotFound/NotFoundPage'
import { getServiceBySlug } from '../../content/services'
import { getEntryByIdString } from '../../content/registry'
import { buildPageMeta } from '../../seo/meta'

export const handle = { locale: 'en' }

export function meta({ params }: { params: Record<string, string | undefined> }): MetaDescriptor[] {
  const service = getServiceBySlug(params.serviceId ?? '', 'en')
  if (!service) return [{ title: '404' }, { name: 'robots', content: 'noindex, follow' }]
  const entry = getEntryByIdString(`service:${service.id}`)
  return entry ? buildPageMeta({ entry, locale: 'en' }) : []
}

export default function Route() {
  const { serviceId } = useParams()
  const service = getServiceBySlug(serviceId ?? '', 'en')
  if (!service) return <NotFoundPage locale='en' />
  return <ServicePageTemplate service={service} locale='en' />
}
